var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-bottom index"},[_c('p',{staticClass:"m-copyright"},[_vm._v("Copyright 2002-今 南京奥派信息产业股份公司 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("苏ICP备12023604号-1")])])])
}]

export { render, staticRenderFns }